{
  "faq.who-and-when.q": {
    "text": "谁必须加入？何时加入？",
    "sourceHash": "251bbd2c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.0": {
    "text": "每家已注册 GST 的企业都必须使用 InvoiceNow-Ready 解决方案向 IRAS 提交发票数据，分阶段实施，最迟于2031年4月1日。",
    "sourceHash": "9767c883",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.1": {
    "text": "如果您已经注册了 GST，您的阶段取决于您在截至 2025 日历年的规定会计期间内的全年供应总额。",
    "sourceHash": "2ee88fe9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.2": {
    "text": "只有除外企业（Excluded Business）不必加入：海外实体，以及完全因反向征收而注册 GST 的企业。",
    "sourceHash": "cee74f72",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.q": {
    "text": "InvoiceNow 是什么？GST 规定是什么意思？",
    "sourceHash": "05be8990",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.0": {
    "text": "InvoiceNow 是新加坡的全国电子发票网络，以国际 Peppol 标准为基础。",
    "sourceHash": "fc70514e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.1": {
    "text": "根据 GST InvoiceNow Requirement，已注册 GST 的企业必须使用 InvoiceNow-Ready 解决方案向 IRAS 提交发票数据。",
    "sourceHash": "eecafed8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.2": {
    "text": "通过电邮发送和接收 PDF 发票不算电子发票。",
    "sourceHash": "a3355442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.q": {
    "text": "是免费的吗？有补助金吗？",
    "sourceHash": "4a32a5cd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.0": {
    "text": "IMDA 的免费（FOC）InvoiceNow 配套名单说明，整个解决方案配套完全免费，不附带任何条件。",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.1": {
    "text": "为已注册 GST 企业提供的免费配套可用至2031年3月31日。",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.2": {
    "text": "各供应商的开始和结束日期不同，请查看名单上您所选配套的日期。",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.3": {
    "text": "补助金包括：给全年供应总额不超过 S$4 百万的企业的 S$1,000 Transition Grant、给连接自己 ERP 的较大企业的 S$5,000 Transition Grant，以及 S$25,000 的 Queen Bee Grant。",
    "sourceHash": "f1558d4b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.4": {
    "text": "中小企业也可以使用 Productivity Solutions Grant，抵销最高 50% 的合格软件订阅费用。",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.q": {
    "text": "如果我的客户不在 InvoiceNow 上怎么办？",
    "sourceHash": "e540e56d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.0": {
    "text": "您仍然要遵守规定。在网络外开具的销售发票，会以由解决方案提取的发票（Type 2）提交给 IRAS；您的 InvoiceNow-Ready 解决方案会定期自动提取并发送。",
    "sourceHash": "a6b5e467",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.1": {
    "text": "您仍然必须收集客户的名称、UEN 和地址，因为它们是强制数据元素。对于海外客户，请把他们的海外商业注册号码填作 Customer UEN。",
    "sourceHash": "ec014db2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.2": {
    "text": "对于未注册 GST 的个人客户，您可以在 Customer Name 和 Customer UEN 两个栏位都填 \"NA\"。",
    "sourceHash": "9d4ff1ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.3": {
    "text": "您不必核实客户资料，但要保存能支持这些资料的记录。",
    "sourceHash": "5ef1d019",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.4": {
    "text": "Access Point 供应商无法把 PDF 或纸质发票转换成 Peppol 格式。",
    "sourceHash": "9a74f877",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.q": {
    "text": "我可以获得豁免或选择不参加吗？",
    "sourceHash": "eec59ad2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.0": {
    "text": "不能选择不参加：除除外企业（Excluded Business）以外，所有已注册 GST 的企业都必须遵守。",
    "sourceHash": "6dc42750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.1": {
    "text": "IRAS 表示，只向关联实体供应的企业、小型或交易量少的企业，以及只有零税率或免税供应的企业，都不能获得豁免。",
    "sourceHash": "767e74af",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.2": {
    "text": "如果您的企业属于共用 ERP 系统的商业安排（例如特许经营集团），而该系统需要更多时间，您可以写信给 IRAS 申请推迟实施日期。IRAS 会逐一考虑每项申请。",
    "sourceHash": "0b296961",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.q": {
    "text": "有什么罚则？IRAS 会有多严格？",
    "sourceHash": "3dbc8ace",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.0": {
    "text": "IRAS 表示，在初期阶段，对于发票数据中并非因疏忽或在没有合理理由下造成的真正错误，会调整其执法方式。",
    "sourceHash": "42096166",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.1": {
    "text": "到2031年4月1日，所有其余已注册 GST 的企业都必须遵守，未遵守的企业可能会面对执法行动。",
    "sourceHash": "655f4a55",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.2": {
    "text": "如果您从2025年11月1日起自愿注册而没有遵守，您的申请可能被拒绝，或注册被撤销。",
    "sourceHash": "f9f72473",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.3": {
    "text": "您应检查发票数据与消费税申报表是否一致；但合理的差异（例如时间差、无需开发票的供应，或未全额申报的进项税），只要您保存记录并能在被要求时出示，就不会被罚。",
    "sourceHash": "cb6f8153",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.q": {
    "text": "我通过 POS 或收银机销售。我需要 Peppol 发票吗？",
    "sourceHash": "2124fbf0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.0": {
    "text": "不需要。POS 销售可以继续给客户收据，不必开具 Peppol 发票。",
    "sourceHash": "1a55e4f4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.1": {
    "text": "您仍然必须把销售数据提交给 IRAS。您可以汇总记录 POS 销售，汇总后的数据会以由解决方案提取的发票发送。",
    "sourceHash": "059e5f23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.2": {
    "text": "可以汇总的包括：POS 供应、开具简化税务发票或收据的供应，以及零用现金采购，例如员工报销和公司卡采购。",
    "sourceHash": "30250c9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.3": {
    "text": "请向您的 InvoiceNow-Ready 解决方案供应商询问如何整合您的 POS 系统。",
    "sourceHash": "4c379c26",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.q": {
    "text": "提交发票数据的截止日期是什么时候？",
    "sourceHash": "0ca198b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.0": {
    "text": "所有发票数据都必须在以下两个日期中较早的一个之前送达 IRAS：您提交相关消费税申报表的日期，或该申报表的提交截止日期。",
    "sourceHash": "801941ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.1": {
    "text": "相关消费税申报表，是指涵盖交易发生的会计期间的那一份申报表。",
    "sourceHash": "9c3a59aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.2": {
    "text": "Peppol 发票（Type 1A）一般会实时或接近实时送达 IRAS。由解决方案提取的提交（Types 1B、2 和 3）可以通过您的解决方案定期安排。",
    "sourceHash": "c28259ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.q": {
    "text": "我怎么知道提交成功了？",
    "sourceHash": "d60095a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.0": {
    "text": "每次成功传送，您都会通过 InvoiceNow-Ready 解决方案收到 IRAS 发出的确认编号（acknowledgement ID），表示 IRAS 已收到提交。",
    "sourceHash": "a8751f73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.1": {
    "text": "InvoiceNow-Ready 解决方案供应商应让您查看每次提交的日期和时间、状态以及 IRAS 确认编号。显示方式因供应商而异。",
    "sourceHash": "27207ce6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.q": {
    "text": "更正、重新提交和贷项通知单怎么处理？",
    "sourceHash": "da88dfe8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.0": {
    "text": "如果您在解决方案中修改了发票记录，例如 GST 类别代码，就必须重新提交发票数据。IRAS 会以最后一次提交作为最新记录。",
    "sourceHash": "497f109f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.1": {
    "text": "如果您在提交采购数据时无法确定最终的进项税处理方式，在发票金额没有改变的情况下，您不必作追溯调整。请保存记录以支持您的处理方式。",
    "sourceHash": "daf5c6fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.2": {
    "text": "这项规定支持两种文件类型：发票和贷项通知单。即使没有调整 GST 金额，也必须提交贷项通知单数据，并使用与原发票相同的 GST 类别代码。",
    "sourceHash": "368b8074",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.3": {
    "text": "对于不影响金额的修改，例如送货地址，供应商会用相同的 Document UUID 发送修订后的发票；否则供应商会开具贷项通知单。",
    "sourceHash": "a734bebb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.q": {
    "text": "我们是消费税集团，规定怎么适用？",
    "sourceHash": "4942fb86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.0": {
    "text": "消费税集团内的实体仍然提交一份合并的消费税申报表。发票数据可以按各实体发送，也可以由集团代表合并发送。",
    "sourceHash": "bd0a81d0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.1": {
    "text": "加入现有消费税集团的新自愿注册企业，跟随该集团的阶段。",
    "sourceHash": "ef5c81ea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.2": {
    "text": "如果集团中有实体属于除外企业（Excluded Business），例如海外实体，只有该实体不必传送发票数据。",
    "sourceHash": "beaab745",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.q": {
    "text": "IRAS 会收到哪些数据？",
    "sourceHash": "4e75adb1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.0": {
    "text": "标准税率和零税率的供应与采购，以及免税供应的发票数据，来源包括发票、收据、借项通知单和贷项通知单。",
    "sourceHash": "8c9b975f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.1": {
    "text": "销售点供应、开具简化税务发票的供应，以及零用现金采购，可以在提交前汇总。",
    "sourceHash": "920fcacd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.2": {
    "text": "缺少任何强制数据元素的数据会被自动拒收。",
    "sourceHash": "e392af3d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.3": {
    "text": "证明文件不必提交，但您必须保存，并在 IRAS 要求时提供。",
    "sourceHash": "afd78d28",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.q": {
    "text": "采购发票也要算吗？",
    "sourceHash": "4f12cfc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.0": {
    "text": "要，标准税率和零税率的采购都要，它们是您申报进项税的依据。",
    "sourceHash": "7672e819",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.1": {
    "text": "您选择不申报进项税的采购不在规定范围内，但您仍然可以用类别代码 \"OP\" 发送。",
    "sourceHash": "80e73039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.q": {
    "text": "我的客户没有注册 GST。我还要发送数据吗？",
    "sourceHash": "4eab912b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.0": {
    "text": "要。无论客户的 GST 身份如何、是否申报进项税，您都必须发送属于规定范围的发票数据。",
    "sourceHash": "09a40f29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.1": {
    "text": "对于未注册 GST 的个人客户，您可以在 Customer Name 和 Customer UEN 栏位填 \"NA\"。",
    "sourceHash": "0fc67bce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.q": {
    "text": "我现在的软件准备好了吗？如果没有怎么办？",
    "sourceHash": "eacb23c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.0": {
    "text": "查看 IMDA 认证的 InvoiceNow-Ready 解决方案供应商名单。如果您的软件不在名单上，您可以请获 IMDA 认证的 Access Point 供应商帮您连接、改用免费配套，或换成 InvoiceNow-Ready 解决方案。",
    "sourceHash": "60964d32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.1": {
    "text": "如果您使用 ERP 系统，就需要一家获 IMDA 认证的 Access Point 供应商，可以直接找，也可以通过您的系统集成商。",
    "sourceHash": "e3b2bf8c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.q": {
    "text": "Access Point 是什么？我需要吗？",
    "sourceHash": "ac631798",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.0": {
    "text": "Access Point（接入点）供应商在 InvoiceNow 网络上运营网关，把发票传送到正确的目的地。",
    "sourceHash": "a247f1a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.1": {
    "text": "InvoiceNow-Ready 解决方案供应商提供的软件，已经通过认证的 Access Point 连接好。",
    "sourceHash": "b329ef94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.2": {
    "text": "要连接您自己的系统或 API，您需要通过获 IMDA 认证的 Access Point 供应商。",
    "sourceHash": "404063b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.q": {
    "text": "我的数据安全吗？我还要提交消费税申报表吗？",
    "sourceHash": "0f62bc53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.0": {
    "text": "只有获 IMDA 认证的 Access Point 供应商可以在网络上运营；数据在传送时加密，并有数字签名。",
    "sourceHash": "ebff2042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.1": {
    "text": "对于收到的发票数据，IRAS 受保密法律约束。",
    "sourceHash": "8e913252",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.2": {
    "text": "您仍然要提交消费税申报表，并保存记录（包括原始凭证）至少 5 年。",
    "sourceHash": "fef52c95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p1.who": {
    "text": "在成立后 6 个月内申请自愿注册 GST 的新成立公司",
    "sourceHash": "c42e068e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p2.who": {
    "text": "在2026年4月1日或之后申请自愿注册 GST 的任何企业",
    "sourceHash": "a972bbdc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p3.who": {
    "text": "在2028年4月1日或之后申请强制注册 GST 的企业，以及全年供应总额 ≤ S$200,000 的现有注册企业",
    "sourceHash": "320d3e46",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p4.who": {
    "text": "全年供应总额 ≤ S$1,000,000 的现有注册企业",
    "sourceHash": "247ce82c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p5.who": {
    "text": "全年供应总额 ≤ S$4,000,000 的现有注册企业",
    "sourceHash": "00be1d53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p6.who": {
    "text": "全年供应总额 > S$4,000,000 的现有注册企业",
    "sourceHash": "0cb8bb21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.totalAnnualSupplies": {
    "text": "全年供应总额，是指在截至 2025 日历年的所有规定会计期间内，标准税率、零税率和免税供应的总值（消费税申报表第 4 栏）。",
    "sourceHash": "8894df11",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.myTaxMail": {
    "text": "IRAS 已从 2026 年年中起，通知在 2026 年之前注册的 GST 企业其强制实施日期。没有截至 2025 年会计期间申报表的企业，稍后会获告知日期。",
    "sourceHash": "64e720e6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "如果您的会计期间在3月、6月、9月和12月结束，请把2025年1月至2025年12月的供应加起来。",
    "sourceHash": "fa00a218",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "如果您的会计期间在1月、4月、7月和10月结束，请把2024年11月至2025年10月的供应加起来。",
    "sourceHash": "11796ab6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "如果您的会计期间在2月、5月、8月和11月结束，请把2024年12月至2025年11月的供应加起来。",
    "sourceHash": "90c6363c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "全年供应总额涵盖截至 2025 日历年的所有规定会计期间。",
    "sourceHash": "1f16e3b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.sum": {
    "text": "全年供应总额是指在截至 2025 日历年的所有规定会计期间内的标准税率、零税率和免税供应。",
    "sourceHash": "c2fbae07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.nil": {
    "text": "零申报仍算作已提交的申报表，因此全年供应总额为 S$0，规定从2028年4月1日起适用。",
    "sourceHash": "e238758b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.extrapolate": {
    "text": "如果您截至 2025 年的申报表只涵盖部分时间，可以把供应折算成 365 天的等值，以确定您的阶段。",
    "sourceHash": "3ae04638",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturns": {
    "text": "如果您没有截至 2025 日历年会计期间的消费税申报表，IRAS 会另行通知您的实施日期。",
    "sourceHash": "75ae99d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturnsPage": {
    "text": "没有截至 2025 年会计期间消费税申报表的企业，其实施日期会稍后通知。",
    "sourceHash": "565bd55d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volFrom2026": {
    "text": "在2026年4月1日或之后申请自愿注册 GST 的企业必须遵守，不论成立日期或企业结构。",
    "sourceHash": "d015650a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volCompulsoryApprovedAsVoluntary": {
    "text": "强制注册申请若获批为自愿注册，也必须遵守。",
    "sourceHash": "5466caab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.newInc": {
    "text": "从2025年11月1日起，在成立后 6 个月内申请自愿注册的新成立公司必须遵守。以申请日期为准，而不是批准日期。",
    "sourceHash": "e5c52505",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.redomiciled": {
    "text": "迁册至新加坡的公司不被视为新成立公司，因此不属于2025年11月1日的阶段。",
    "sourceHash": "41ab4b66",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.compulsory2028": {
    "text": "在2028年4月1日或之后申请强制注册 GST 的企业，从注册起就必须遵守。",
    "sourceHash": "95f33e05",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.group": {
    "text": "加入现有消费税集团的新自愿注册企业，跟随该集团的阶段。集团中只有除外企业（例如海外实体）不必传送发票数据。",
    "sourceHash": "62a4276e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.excluded": {
    "text": "除外企业（Excluded Business，即海外实体，以及完全因反向征收而注册的企业）无需遵守。",
    "sourceHash": "151effd7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.notRegistered": {
    "text": "这项规定适用于已注册 GST 的企业。",
    "sourceHash": "f9b5c7a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p3": {
    "text": "全年供应总额 ≤ S$200,000 的现有 GST 注册企业，必须从2028年4月1日起遵守。",
    "sourceHash": "94fffdf9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p4": {
    "text": "全年供应总额 ≤ S$1,000,000 的现有 GST 注册企业，必须从2029年4月1日起遵守。",
    "sourceHash": "00a99cf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p5": {
    "text": "全年供应总额 ≤ S$4,000,000 的现有 GST 注册企业，必须从2030年4月1日起遵守。",
    "sourceHash": "61ee6fb8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p6": {
    "text": "全年供应总额 > S$4,000,000 的现有 GST 注册企业，必须从2031年4月1日起遵守。",
    "sourceHash": "75b75ad3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.0": {
    "text": "IMDA 的免费（FOC）InvoiceNow 配套名单说明，整个解决方案配套完全免费，不附带任何条件。",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.1": {
    "text": "为已注册 GST 企业提供的免费配套可用至2031年3月31日。",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.2": {
    "text": "各供应商的开始和结束日期不同，请查看名单上您所选配套的日期。",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.amount": {
    "text": "免费",
    "sourceHash": "97a522db",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.who": {
    "text": "已注册 GST 的企业",
    "sourceHash": "f0c80296",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.period": {
    "text": "可用至2031年3月31日；各供应商日期不同",
    "sourceHash": "c211f3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.hrefLabel": {
    "text": "免费配套名单",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.amount": {
    "text": "S$1,000",
    "sourceHash": "2d421df5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.who": {
    "text": "全年供应总额 ≤ S$4 百万（截至 2025 年的会计期间）",
    "sourceHash": "ae19ad94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.period": {
    "text": "2026年7月1日至2030年3月31日，或直到申请完毕",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.hrefLabel": {
    "text": "申请表格",
    "sourceHash": "00a2767f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.0": {
    "text": "现金补助，用于订阅 InvoiceNow-Ready 解决方案供应商（IRSP）或通过获 IMDA 认证的 Access Point 连接。",
    "sourceHash": "fb34e4f6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.1": {
    "text": "在2026年2月26日之后订阅 IRSP 解决方案（至少付费 12 个月），或把您的 ERP 与认证 Access Point 整合。",
    "sourceHash": "a0c5bbcc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.2": {
    "text": "如果您在加入前 3 个月内使用过任何 IRSP 解决方案，就不符合资格。",
    "sourceHash": "f5885c0d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.3": {
    "text": "您必须在强制截止日期之前启用 GST InvoiceNow，并向 IRAS 提交数据。",
    "sourceHash": "33ddaf12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.amount": {
    "text": "S$5,000",
    "sourceHash": "14515e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.who": {
    "text": "全年供应总额 > S$4 百万（截至 2025 年的会计期间），且使用自己的 ERP",
    "sourceHash": "57f19348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.period": {
    "text": "2026年7月1日至2028年3月31日，或直到申请完毕",
    "sourceHash": "a0cd6aa0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.hrefLabel": {
    "text": "意向书（Expression of interest）",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.0": {
    "text": "现金补助，用于通过获 IMDA 认证的 Access Point，把您自己的 ERP 连接到 GST InvoiceNow。",
    "sourceHash": "f972f0b2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.1": {
    "text": "在2026年2月26日之后开始项目，在 12 个月内完成，并在2028年3月31日之前启用 GST InvoiceNow 和向 IRAS 提交发票数据。",
    "sourceHash": "c8e4eb5d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.2": {
    "text": "您可以先提交意向书（Expression of Interest），在符合所有条件后再申请。",
    "sourceHash": "06b50f7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.amount": {
    "text": "S$25,000",
    "sourceHash": "527e6ba3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.who": {
    "text": "年营业额 > S$4 百万，且使用自己的定制 ERP",
    "sourceHash": "beb5790b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.period": {
    "text": "2026年7月1日至2030年3月31日，或直到申请完毕",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.hrefLabel": {
    "text": "意向书（Expression of interest）",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.0": {
    "text": "用于把您自己的定制 ERP 连接到 InvoiceNow，并在网络上与您的商业伙伴进行交易。",
    "sourceHash": "866c9f97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.1": {
    "text": "需要至少 200 家供应商或 200 家企业客户，并在2031年3月31日之前通过 InvoiceNow 接收至少 20 家供应商的发票，或向至少 40 家客户发送发票。",
    "sourceHash": "6e7cf731",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.2": {
    "text": "可以与 S$5,000 的 Transition Grant 合并申请。",
    "sourceHash": "2f0cb8f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.psg": {
    "text": "中小企业也可以使用 Productivity Solutions Grant，抵销最高 50% 的合格软件订阅费用。",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.irspCount": {
    "text": "IMDA 的 InvoiceNow-Ready 解决方案服务商名单（2026 年 10 月 12 日更新）列出 81 家服务商，另有经销商。",
    "sourceHash": "7a5927d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.inHouseConnect": {
    "text": "对于内部企业系统，应预留 3 至 12 个月完成与 IRAS 的系统连接。",
    "sourceHash": "df11b6c4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.lead": {
    "text": "更顺畅",
    "sourceHash": "1c9ecb39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.text": {
    "text": "发票以结构化数据在财务系统之间传送，不用手动发送、签收或重新输入。",
    "sourceHash": "17223d30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.lead": {
    "text": "更少错误",
    "sourceHash": "c89722c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.text": {
    "text": "减少手工作业，就能减少错误和更正成本，也能降低储存和查找成本。",
    "sourceHash": "9f1a5b7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.lead": {
    "text": "GST 检查",
    "sourceHash": "40d0c5f2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.text": {
    "text": "InvoiceNow-Ready 解决方案可以内置检查，在未注册 GST 的供应商错收 GST 时提醒您。",
    "sourceHash": "5e3dbd1c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.lead": {
    "text": "节省成本",
    "sourceHash": "dc787b50",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.text": {
    "text": "企业通过减少手工处理，每张发票最多可节省 $20。",
    "sourceHash": "4f67845a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.lead": {
    "text": "错误率",
    "sourceHash": "c30963ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.text": {
    "text": "研究还显示，电子发票最多可将发票错误率降低 50%。",
    "sourceHash": "b0fff20f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.group": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.0.why": {
    "text": "官方页面：谁必须加入、日期和该做什么。",
    "sourceHash": "a19554a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.1.why": {
    "text": "给已注册 GST 企业的完整指南，包括四种提交类型。",
    "sourceHash": "c24f442e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.2.why": {
    "text": "企业常见问题的详细解答。",
    "sourceHash": "7edaf727",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.3.why": {
    "text": "IRAS 自己的电子表格，用来查您的实施日期。",
    "sourceHash": "f017ed20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.4.why": {
    "text": "向 IRAS 询问规定如何适用于您的企业。",
    "sourceHash": "ea023a06",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.5.why": {
    "text": "由 InvoiceNow-Ready 解决方案供应商举办、由 IRAS 列出的活动。",
    "sourceHash": "9d236c3a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.group": {
    "text": "IMDA",
    "sourceHash": "ca38b594",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.0.why": {
    "text": "关于 InvoiceNow、网络及其好处。",
    "sourceHash": "2396384d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.1.why": {
    "text": "免费配套，以及 S$1k、S$5k 和 Queen Bee 补助金，附申请表格。",
    "sourceHash": "2612fe7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.2.why": {
    "text": "补助金资格和截止日期的一页摘要。",
    "sourceHash": "b16a1d7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.3.why": {
    "text": "谁符合补助金资格，以及如何申请。",
    "sourceHash": "a969c667",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.4.why": {
    "text": "可用来收发发票并向 IRAS 报告的认证软件。",
    "sourceHash": "cf1739ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.5.why": {
    "text": "认证 Access Point 供应商，适合使用自己 ERP 或内部系统的企业。",
    "sourceHash": "80ed385f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.6.why": {
    "text": "给已注册 GST 企业的免费解决方案配套，附各供应商的日期。",
    "sourceHash": "5035af93",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.7.why": {
    "text": "请免费解决方案供应商回电给您。",
    "sourceHash": "f57ad21b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.8.why": {
    "text": "向 IMDA 询问 InvoiceNow 和补助金。",
    "sourceHash": "2238ebe6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.group": {
    "text": "了解更多",
    "sourceHash": "d517a63a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.0.why": {
    "text": "IRAS 与 IMDA 关于如何准备的网络研讨会。",
    "sourceHash": "efd6e4ff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.1.why": {
    "text": "搜索某家企业是否在 InvoiceNow 网络上。",
    "sourceHash": "dd4bd766",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.group": {
    "text": "阅读官方常见问题",
    "sourceHash": "274bf870",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.0.why": {
    "text": "关于规定的问题，2026年9月23日版本。",
    "sourceHash": "5db27b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.1.why": {
    "text": "资格和申请。",
    "sourceHash": "9f9bbe9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.group": {
    "text": "关于您本身情况的问题",
    "sourceHash": "35540ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.0.why": {
    "text": "向 IRAS 询问规定如何适用于您的企业。",
    "sourceHash": "a687ae87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.1.why": {
    "text": "向 IMDA 询问 InvoiceNow、网络和补助金。",
    "sourceHash": "88920956",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.group": {
    "text": "在找供应商？",
    "sourceHash": "d32a0c7c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.0.why": {
    "text": "请免费解决方案供应商回电。",
    "sourceHash": "85f05924",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.1.why": {
    "text": "您可以参加的供应商活动。",
    "sourceHash": "29248e22",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.title": {
    "text": "补助金和设置指南有了独立页面",
    "sourceHash": "0988e2b2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.0": {
    "text": "新的补助金页面：S$1,000 和 S$5,000 的 GST InvoiceNow 过渡补助金、S$25,000 的 Queen Bee 补助金和生产力解决方案补助金，以及相关的常见问题解答。",
    "sourceHash": "550aa9fe",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.1": {
    "text": "“软件与补助金”页面现在介绍免费配套、服务商名单和“哪个方案适合我？”小工具，并链接到补助金页面。",
    "sourceHash": "c308dd08",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.2": {
    "text": "新的设置指南：清单的五个步骤集中在一页，每一步都附有官方出处，另有 Peppol ID 查询，以及使用 InvoiceNow 时在哪里登录。",
    "sourceHash": "7b1f25ae",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.3": {
    "text": "软件与补助金：新增表格，显示常用会计软件（Xero、AutoCount、ABSS、SAP Business One、QuickBooks 等）是否在 IMDA 2026 年 10 月 12 日的 InvoiceNow-Ready 解决方案服务商名单上。",
    "sourceHash": "b3359b0e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.4": {
    "text": "页面标题更清楚。",
    "sourceHash": "bce15627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.title": {
    "text": "语言切换、清单链接和首页数据",
    "sourceHash": "ca71b95b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.0": {
    "text": "简体中文、马来文和泰米尔文页面现已以翻译草稿形式提供，在母语人士审校之前会清楚标明。可在任何页面顶部选择语言。",
    "sourceHash": "ea952d87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.1": {
    "text": "清单的每个步骤现在都链接到本网站上相应的页面或工具。",
    "sourceHash": "0244a948",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.2": {
    "text": "首页的好处部分新增两项数据：每张发票最多可节省 $20，以及发票错误率最多可降低 50%。",
    "sourceHash": "0867745b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.3": {
    "text": "“免费软件”页面现已改名为“软件与补助金”，并新增“哪个选项适合我？”工具。每个页面顶部的“我该怎么做？”按钮会打开清单。",
    "sourceHash": "b845a176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.title": {
    "text": "已准备中文、马来文和淡米尔文版本",
    "sourceHash": "2b37db34",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.0": {
    "text": "本站现在可以用简体中文、马来文和淡米尔文显示。翻译是非官方的，以英文版本为准。",
    "sourceHash": "b1ce89f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.1": {
    "text": "一个页面只有在母语人士审校了其中每一句之后，才会以该语言发布。",
    "sourceHash": "78d0cacb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.title": {
    "text": "按主题拆分成多个页面",
    "sourceHash": "1bad2e23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.0": {
    "text": "原本很长的首页现在是一个附清单的简短概览。日期与计算器、免费软件与补助金、运作方式、POS 与零售，以及常见问题，各有自己的页面。",
    "sourceHash": "e829e950",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.title": {
    "text": "来自 IRAS 常见问题的新回答，以及更精确的日期计算器",
    "sourceHash": "0b41e916",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.0": {
    "text": "新的常见问题回答：POS 与汇总销售、提交截止日期、确认编号、重新提交与贷项通知单、消费税集团注册、不在 InvoiceNow 上的客户，以及罚则。",
    "sourceHash": "48230640",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.1": {
    "text": "日期计算器现在按照 IRAS 常见问题 Q1.5 至 Q1.12 和 Q7.2：非日历年会计期间、零申报、部分年度申报表、自愿和新强制注册企业、迁册公司、除外企业和消费税集团。",
    "sourceHash": "cad24b17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.title": {
    "text": "更清楚地说明独立性和出处",
    "sourceHash": "1b786b97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.0": {
    "text": "每个页面顶部现在都有横幅，说明本站是独立网站，与 IRAS 或 IMDA 无关。",
    "sourceHash": "bff02dff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.1": {
    "text": "新的“关于本站”页面：网站为何存在、内容如何核对，以及隐私。",
    "sourceHash": "37457db6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.2": {
    "text": "新的公开更新记录（本页）。",
    "sourceHash": "e84748e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.3": {
    "text": "首页显示内容最近一次对照官方来源核对的日期。",
    "sourceHash": "34039bc5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.title": {
    "text": "内容已对照最新的 IRAS 和 IMDA 来源核对",
    "sourceHash": "7658597f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.0": {
    "text": "免费配套：现在依据 IMDA 2026年9月17日的名单（免费且不附带条件，可用至2031年3月31日，各供应商日期不同）。删除了没有出处的“部分供应商按次或按订阅收费”一句。",
    "sourceHash": "5bb75433",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.1": {
    "text": "豁免：把“豁免申请会被拒绝”改为 IRAS 常见问题 Q2.6 和 Q1.14 的实际内容。",
    "sourceHash": "c9587149",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.2": {
    "text": "现在每一句都注明出处，附上常见问题题号和 e-Tax Guide 段落。",
    "sourceHash": "9d9ae8f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.3": {
    "text": "删除了首页三项无法追溯到官方来源的统计数字（每张发票节省的费用、付款速度、错误率）。",
    "sourceHash": "f2596592",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.4": {
    "text": "连接内部系统需要 3 至 12 个月的说明，现在引用 e-Tax Guide 第 13.6 段。",
    "sourceHash": "aa9c55a2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
